module.exports = __webpack_public_path__ + "img/escalante.2604c84b.png";